import { render, staticRenderFns } from "./MenuItemDestination.vue?vue&type=template&id=92cea3b4"
import script from "./MenuItemDestination.vue?vue&type=script&lang=js"
export * from "./MenuItemDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports